import { render, staticRenderFns } from "./GatButtonGroup.vue?vue&type=template&id=0aa73b6e&scoped=true&"
import script from "./GatButtonGroup.vue?vue&type=script&lang=js&"
export * from "./GatButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa73b6e",
  null
  
)

export default component.exports